import { render, staticRenderFns } from "./ImportedGroups.vue?vue&type=template&id=5f4f5545&scoped=true&"
import script from "./ImportedGroups.vue?vue&type=script&lang=js&"
export * from "./ImportedGroups.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=5f4f5545&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4f5545",
  null
  
)

export default component.exports